import React, { useState, useEffect } from "react";
import { FoodsObj } from "../../../api/model/response/OnlineMenuResponseModel";
import { useUserContext } from "../../../context/UserContext";
import AddIcon from "@mui/icons-material/Add";
import "./addToCartIcon.scss";

interface AddToCartIconProps {
  food: FoodsObj;
  isPressed: string;
  setIsPressed: React.Dispatch<React.SetStateAction<string>>;
  backgroundColor?: string;
  color?: string;
  type: "food" | "subfood";
  categoryId: string;
}

const AddToCartIcon: React.FC<AddToCartIconProps> = ({
  food,
  isPressed,
  setIsPressed,
  backgroundColor = "#6767e7",
  color = "white",
  type,
  categoryId = ""
}) => {
  const { setOrders, orders, isCartActive } = useUserContext();

  const handleAddToCart = (clickedFood: FoodsObj) => {
    const existingOrder = orders.find((x) => x.id === clickedFood.id && x.type === type);
    if (existingOrder) {
      setOrders((prevOrders) =>
        prevOrders.map((order) => {
          if (order.id === clickedFood.id && order.type === type) {
            return {
              ...order,
              quantity: order.quantity + 1
            };
          }
          return order;
        })
      );
      return;
    }
    setOrders((prevOrders) => [
      ...prevOrders,
      {
        id: clickedFood.id || "",
        name: clickedFood.title || "",
        orderPrice: clickedFood.orderPrice || 0,
        photoUrl: clickedFood.photoUrl || "",
        quantity: 1,
        categoryId: categoryId,
        type: type
      }
    ]);
  };

  // Implement the component logic here

  return (
    <>
      {isCartActive && (
        <div
          className={`plus-icon ${isPressed === food.id ? "active" : ""}`}
          onClick={() => {
            setIsPressed(food.id || "");
            handleAddToCart(food);
          }}
          onTouchEnd={() => {
            setTimeout(() => setIsPressed(""), 200);
          }}
          style={{ backgroundColor, color }}
        >
          <AddIcon />
        </div>
      )}
    </>
  );
};

export default AddToCartIcon;
